// extracted by mini-css-extract-plugin
export var active = "CruiseSegmentCard-module--active--2eb62";
export var container = "CruiseSegmentCard-module--container--b87ee";
export var containerTitanium = "CruiseSegmentCard-module--container-titanium--d65a2";
export var cruiseName = "CruiseSegmentCard-module--cruise-name--61486";
export var dates = "CruiseSegmentCard-module--dates--1482e";
export var title = "CruiseSegmentCard-module--title--d00b7";